import { render, staticRenderFns } from "./AllegatoModelComponent.vue?vue&type=template&id=472d9758"
import script from "./AllegatoModelComponent.vue?vue&type=script&lang=js"
export * from "./AllegatoModelComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports